export const RECOMMENDATION_SOURCE = {
    CHAT_AGENT: 'CHAT_AGENT',
};
